const TileNeighbor = ({ data = {}, t }) => {
  const toStr = (v) =>
    typeof v === "string" ? v.trim() : typeof v === "number" ? String(v) : "";
  const neighbor = toStr(data.neighbor),
    url = toStr(data.url),
    address = toStr(data.address);
  if (!neighbor && !url && !address) return null;
  const label = {
    fontSize: 10,
    textTransform: "uppercase",
    letterSpacing: "0.06em",
    fontWeight: 500,
    color: t.textMuted,
    margin: 0,
  };
  const val = {
    fontSize: 13,
    color: t.textSecondary,
    margin: 0,
    wordBreak: "break-word",
  };

  return (
    <div>
      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        {neighbor && (
          <p
            style={{
              fontSize: 15,
              fontWeight: 600,
              color: t.textPrimary,
              margin: 0,
              wordBreak: "break-word",
              lineHeight: 1.4,
            }}
          >
            {neighbor}
          </p>
        )}
        {(url || address) && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 10,
              paddingTop: 12,
              borderTop: `1px solid ${t.divider}`,
            }}
          >
            {url && (
              <div>
                <p style={label}>URL</p>
                <p style={val}>{url}</p>
              </div>
            )}
            {address && (
              <div>
                <p style={label}>Address</p>
                <p style={val}>{address}</p>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default TileNeighbor;
